<template>
  <app-content class="h-panel" >
    <div class="h-panel-bar"><span class="h-panel-title">用户管理</span></div>
    <div class="margin-top margin-left">
      <Button color="primary" @click="showForm=true">新增</Button>
    </div>
    <div class="h-panel-body">
      <Table :datas="datas" :border="true" >
        <TableItem title="用户名" prop="realName" align="center"></TableItem>
        <TableItem title="手机号" prop="mobile" align="center"></TableItem>

        <TableItem title="创建时间" prop="createDate" align="center"></TableItem>
<!--        <TableItem title="权限分配" align="center">
          <div class="actions" slot-scope="{data}">
            <template >
              <span @click="details(data)">详情</span>
            </template>
          </div>
        </TableItem>-->
        <TableItem title="操作" align="center">
          <div class="actions" slot-scope="{data}">
            <template >
              <span @click="edit(data)">编辑</span>
              <span @click="remove(data)" v-if="data.id!=1">删除</span>
            </template>
          </div>

        </TableItem>
      </Table>

    </div>

    <Modal v-model="showForm" hasCloseIcon type="drawer-right">
      <div slot="header">用户信息</div>
      <Form ref="form" v-width="500" :labelWidth="80" :model="form" :rules="validationRules">
        <FormItem label="手机号码" prop="mobile">
          <input type="text" v-model="form.mobile" >
        </FormItem>
        <FormItem label="用户名" prop="realName">
          <input type="text" v-model="form.realName" >
        </FormItem>


<!--        <Radio class="cus-h-radio" v-model="form.role" :datas="roles">
          <template slot="item" slot-scope="{item}">
            <span>{{item.title}}</span>
            <div class="desc">{{item.desc}}</div>
          </template>
        </Radio>-->
      </Form>
      <div class="text-center margin-top">
        <Button color="green" @click="addUser" :loading="loading">{{!form.id?'确定':'更新'}}</Button>
        <Button @click="showForm=false">取消</Button>
      </div>
    </Modal>
    <Modal v-model="showNewForm" hasCloseIcon>
      <div class="h-panel-body" >

        <Table :datas="dataList" :border="true" >
          <TableItem title="关联账套" prop="companyName" align="center">
          </TableItem>
          <TableItem title="关联权限" prop="roleType" dict="roles" align="center">
          </TableItem>
        </Table>

      </div>
    </Modal>

  </app-content>
</template>

<script>

import {mapState} from 'vuex';
import SmsVerificationCode from "../../components/SmsVerificationCode";
import setting from "@/api/setting";

const emptyForm = {
  "realName": "",
  "mobile": "",

};

export default {
  name: 'User',
  components: {SmsVerificationCode},
  data() {
    return {
      datas: [],
      dataList: [],

      roles: [
        {
          key: 'Manager',
          title: '账套管理员',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 | 删除账套'
        }, {
          key: 'Making',
          title: '制单人',
          desc: '凭证 | 结账 | 账簿 | 报表 | 新增账套 '
        }, {
          key: 'View',
          title: '查看',
          desc: '查看凭证、账簿和报表 | 新增账套'
        }],
      form: Object.assign({}, emptyForm),
      showNewForm: false,
      showHandOver: false,
      showForm: false,
      loading: false,
      authenticated: false,
      receiverMobile: '',
      msgSended: false,
      msgTxt: '发送验证码',
      msgCode: '',
      verificationCode: '',
      validationRules: {
        required: ['mobile','realName'],
        mobile: ['mobile'],
        realName: ['realName']
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets', 'User']),
  },
  watch: {
    showForm(val) {
      if (!val) {
        this.reset();
      }
    }
  },
  methods: {
    loadList() {
      this.$api.setting.user.list().then(({data}) => {
        this.datas = data || [];

      })
    },
    addUser() {
      let validResult = this.$refs.form.valid();
      if(validResult.result){
        /*setting.user.add(this.form).then((data)=>{
          this.showForm = false;
          this.loadList()
        })*/
        setting.user[this.form.id ? 'update' : 'save'](this.form).then(()=>{
          this.loadList();
          this.showForm = false;
        })
      }


    },
    addNewUser() {
      if (!this.msgCode) {
        this.$Message('请输入验证码！');
        return
      }

      this.loading = true;
      this.$api.setting.accountSets.addNewUser(Object.assign({}, this.form, {code: this.msgCode})).then(() => {
        this.loadList();
        this.showForm = false;
        this.showNewForm = false;
        this.loading = false;
      }).catch((rs) => {
        this.loading = false;
      });
    },

    edit(data) {
      this.form = {
        realName: data.realName,
        mobile: data.mobile,
        id: data.id
      };
      this.showForm = true;
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        setting.user.delete(data.id).then(() => {
          this.loadList();
        })
      })
    },
    reset() {
      this.form = Object.assign({}, emptyForm);
    },
    handOver() {
      if (this.verificationCode) {
        if (!this.authenticated) {
          //移交人身份确认
          this.$api.setting.accountSets.identification({code: this.verificationCode}).then(() => {
            this.verificationCode = "";
            this.authenticated = true;
          });
        } else {

          this.$api.setting.accountSets.handOver({mobile: this.receiverMobile, code: this.verificationCode}).then(() => {
            window.location.replace("/");
          });
        }
      }
    }
  },
  mounted() {
    this.loadList();
  }
};
</script>
<style lang="less">
.cus-h-radio {
  > label {
    display: block;
    height: auto;

    .desc {
      color: @dark4-color;
      padding-left: 20px;
    }
  }
}
</style>
